import { render, staticRenderFns } from "./ModalCreateDataselection.vue?vue&type=template&id=9f74d68e&"
import script from "./ModalCreateDataselection.vue?vue&type=script&lang=js&"
export * from "./ModalCreateDataselection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports